import React, { FC } from 'react';
import { Stack } from '@mui/material';
import CustomSelect from '../../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../../utils/utils';
import CustomDateInput from '../../CustomDateInput';
import useTranslation from '../../../hooks/useTranslation';

const SiteProgressInfoFields: FC = () => {
  const t = useTranslation();
  return (
    <>
      <CustomSelect
        optionsArray={getOptionsFromTranslation(t, 'siteProgress')}
        name={'siteProgress'}
        label={t('labels.siteProgress')}
        dataTestID={'site-progress'}
      />

      <Stack direction="row" spacing={3}>
        <CustomDateInput
          label={'labels.siteAgreementSignDate'}
          name={'siteAgreementSignedDate'}
          dataTestID={'agreement-signed-date'}
        />
        <CustomDateInput
          label={'labels.siteAccessibleDate'}
          name={'siteAccessibleDate'}
          dataTestID={'accessible-date'}
        />
      </Stack>
    </>
  );
};

export default SiteProgressInfoFields;
